import { render } from "./ErpForm.vue?vue&type=template&id=54f752c5&scoped=true"
import script from "./ErpForm.vue?vue&type=script&lang=js"
export * from "./ErpForm.vue?vue&type=script&lang=js"

import "./ErpForm.vue?vue&type=style&index=0&id=54f752c5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54f752c5"]])

export default __exports__